import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { Provider } from 'react-redux'
import store from '../src/reduxStore/store.js'
import ClerkProviderWithRoutes from './auth/ClerkProviderWithRoutes.jsx'
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'
import { initTheme } from './theme/darkMode'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient'
import SessionLoading from './components/SessionLoading'

import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
ModuleRegistry.registerModules([AllCommunityModule]);

const persistor = persistStore(store)
initTheme();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ClerkProviderWithRoutes>
        <Provider store={store}>
          <PersistGate loading={<SessionLoading />} persistor={persistor}>
            <App />
          </PersistGate>
        </Provider>
      </ClerkProviderWithRoutes>
    </QueryClientProvider>
  </StrictMode>,
)
